var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventReminder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gear-six-thin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 21,
    height: 21,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(7 7)",
    fill: "none",
    stroke: "#ff9e17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M37.99,33.093a5.958,5.958,0,0,1,.51.882l2.1,1.166A8.257,8.257,0,0,1,40.6,38.7l-2.1,1.166a5.957,5.957,0,0,1-.51.882l.04,2.4a8.419,8.419,0,0,1-3.084,1.789l-2.064-1.239a7.148,7.148,0,0,1-1.02,0l-2.056,1.23a8.306,8.306,0,0,1-3.092-1.781l.04-2.4a6.484,6.484,0,0,1-.51-.89l-2.1-1.166a8.257,8.257,0,0,1-.008-3.562l2.1-1.166a5.958,5.958,0,0,1,.51-.882l-.04-2.4A8.419,8.419,0,0,1,29.8,28.9l2.064,1.239a7.148,7.148,0,0,1,1.02,0l2.056-1.23a8.306,8.306,0,0,1,3.092,1.781Z",
    transform: "translate(-22.01 -26.56)",
    fill: "none",
    stroke: "#ff9e17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventReminder);
export default __webpack_public_path__ + "static/media/eventReminder.785c32d6561e78b5ddc9e8d4efebb272.svg";
export { ForwardRef as ReactComponent };